import React from "react";
import Table from "../../Common/Table";
import Permission from "../../Common/Permission";
import TableFields from "../../../constants/DriverCashTransactions/TableFields.json";
import { getPath } from "../../../utils";
import BlankState from "../../Common/BlankState";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const DriverCashTransactionsList = (props) => {
  const { driverCashTransactionsList } = props;
  const allActions = MenuActionsMappings[MenuNames.DRIVER_CASH_TRANSACTIONS];
  const getFieldValue = (item, key) => {
    return item[key];
  };
  return (
    <Permission requiredPerms={[allActions.LIST]}>
      {getPath(driverCashTransactionsList, "length", undefined) > 0 ? (
        <Table
          list={driverCashTransactionsList}
          fields={TableFields}
          getFieldValue={getFieldValue}
        />
      ) : (
        <BlankState />
      )}
    </Permission>
  );
};

export default DriverCashTransactionsList;
